/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GroupOrderDetailsQueryVariables = Exact<{
  joinCode: string;
}>;

export type GroupOrderDetailsQuery = {
  readonly multipartyOrderPreview:
    | { readonly __typename: 'MultipartyOrderAlreadyJoined' }
    | { readonly __typename: 'MultipartyOrderNotFound' }
    | { readonly __typename: 'MultipartyOrderPreviewSuccess'; readonly hostDisplayName: string }
    | { readonly __typename: 'OrderLocked' };
};

export const GroupOrderDetailsDocument = gql`
  query GroupOrderDetails($joinCode: String!) {
    multipartyOrderPreview(joinCode: $joinCode) {
      __typename
      ... on MultipartyOrderPreviewSuccess {
        hostDisplayName
      }
    }
  }
`;

export function useGroupOrderDetailsQuery(
  options: Omit<Urql.UseQueryArgs<GroupOrderDetailsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GroupOrderDetailsQuery, GroupOrderDetailsQueryVariables>({
    query: GroupOrderDetailsDocument,
    ...options,
  });
}
